<template>
  <div class="dialog-wrap">
    <el-dialog title="教师编辑" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="handleClose" width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="教师名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入教师名称"></el-input>
        </el-form-item>
        <el-form-item label="教师头像" prop="avatar">
          <el-upload class="avatar-uploader" :action="imgUploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload">
            <img v-if="dataForm.avatar" :src="dataForm.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="教师标签" prop="tags">
          <el-input v-model="dataForm.tags" placeholder="请输入教师标签，至多两个，用英文逗号隔开"></el-input>
        </el-form-item>
        <el-form-item label="教师描述" prop="description">
          <el-input v-model="dataForm.description" placeholder="请输入教师描述"></el-input>
        </el-form-item>
        <el-form-item label="教师手机号" c>
          <el-input v-model="dataForm.mobile" placeholder="请输入教师手机号"></el-input>
        </el-form-item>
        <el-form-item label="教师微信号" prop="wechat">
          <el-input v-model="dataForm.wechat" placeholder="请输入教师微信号"></el-input>
        </el-form-item>
        <el-form-item label="微信链接">
          <el-input v-model="dataForm.wechat_url" placeholder="请输入教师微信链接"></el-input>
        </el-form-item>
        <el-form-item label="微信二维码">
          <el-upload class="avatar-uploader" :action="imgUploadUrl" :headers="uploadHeaders" :show-file-list="false" :on-success="handleUploadQrcodeSuccess" :before-upload="handleBeforeUpload">
            <img v-if="dataForm.qrcode" :src="dataForm.qrcode" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="教师介绍" prop="detail">
          <el-input v-model="dataForm.detail" type="textarea" :rows="2" placeholder="请输入教师介绍"></el-input>
        </el-form-item>
        <el-form-item label="在线客服状态" prop="service_status">
          <el-switch v-model="dataForm.service_status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teacherUpdate } from '@/api/common'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {
        avatar: '',
        qrcode: ''
      },
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        name: [{ required: true, message: '请输入教师名称', trigger: 'blur' }],
        tags: [{ required: true, message: '请输入教师标签', trigger: 'blur' }],
        description: [{ required: true, message: '请输入教师描述', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入教师手机号', trigger: 'blur' }],
        detail: [{ required: true, message: '请输入教师介绍', trigger: 'blur' }],
        avatar: [{ required: true, message: '请上传教师头像', trigger: 'blur' }],
        qrcode: [{ required: true, message: '请上传老师微信二维码', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            tags: this.dataForm.tags,
            description: this.dataForm.description,
            mobile: this.dataForm.mobile,
            wechat: this.dataForm.wechat,
            detail: this.dataForm.detail,
            avatar: this.dataForm.avatar,
            qrcode: this.dataForm.qrcode,
            wechat_url: this.dataForm.wechat_url,
            service_status: this.dataForm.service_status ? 1 : 0
          }
          teacherUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.avatar = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadQrcodeSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.qrcode = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
  }
}
</style>
